import { useNode } from "@craftjs/core";
import React from "react";

import {
  CenterAlignActiveIcon,
  CenterAlignIcon,
  LeftALignActiveIcon,
  LeftALignIcon,
  RightAlignActiveIcon,
  RightAlignIcon,
  PencilActiveIcon,
  PaintIcon,
} from "../../../assets/ui-icons";
import { isUpdatedFromDefault } from "../../utils";

import {
  ColorInput,
  OptionsInput,
  Panel,
  RangeInput,
  SelectInput,
  SpacerInput,
  Tabs,
  TextInput,
} from "./../../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp91 } from "@fortawesome/free-solid-svg-icons";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";
import { INPUT_LIMITS } from "../../input-limits";
import NumberInput from "../../ui-kit/number";

export const CMSCountUpSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    align,
    countStart = 0,
    countEnd = 100,
    countTime = 3,
    numPrefix = "",
    numSuffix = "",
    numTSeparator,
    textColor,
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <NumberInput
            min={INPUT_LIMITS["start-counter"].min}
            max={INPUT_LIMITS["start-counter"].max}
            resetValue={0}
            label="Start"
            value={countStart}
            onChange={(val) => {
              setProp((props) => {
                props.countStart = val;
              });
            }}
          />
          <NumberInput
            min={INPUT_LIMITS["end-counter"].min}
            max={INPUT_LIMITS["end-counter"].max}
            resetValue={100}
            label="End"
            value={countEnd}
            onChange={(val) => {
              setProp((props) => {
                props.countEnd = val;
              });
            }}
          />
          <RangeInput
            resetValue={3}
            min={INPUT_LIMITS["count-up-time"].min}
            max={INPUT_LIMITS["count-up-time"].max}
            label="Time"
            value={countTime}
            onChange={(val) => {
              setProp((props) => {
                props.countTime = val;
              });
            }}
          />

          <TextInput
            resetValue={""}
            label="Number Prefix"
            value={numPrefix}
            onChange={(val) => {
              setProp((props) => {
                props.numPrefix = val.target.value;
              });
            }}
            minLength={INPUT_LIMITS["counter-prefix"].minlength}
            maxLength={INPUT_LIMITS["counter-prefix"].maxlength}
          />
          <TextInput
            resetValue={""}
            minLength={INPUT_LIMITS["counter-suffix"].minlength}
            maxLength={INPUT_LIMITS["counter-suffix"].maxlength}
            label="Number Suffix"
            value={numSuffix}
            onChange={(val) => {
              setProp((props) => {
                props.numSuffix = val.target.value;
              });
            }}
          />
          <SelectInput
            label="Thousands Separator"
            value={numTSeparator}
            onChange={(val) => {
              setProp((props) => {
                props.numTSeparator = val;
              });
            }}
            options={[
              {
                label: ",",
                value: ",",
              },
              {
                label: ".",
                value: ".",
              },
            ]}
          />
          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            options={[
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
        </SpacerInput>
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              value={textColor}
              onChange={(val) => {
                setProp((props) => {
                  props.textColor = val;
                });
              }}
              label={"Text"}
              useTextColorPalette={true}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];
  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar
            title={" Count Up"}
            icon={
              <FontAwesomeIcon icon={faArrowUp91} size="2xl" color="#8402E9" />
            }
          />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
